<template>
  <draggable
    v-if="competencies.length"
    v-model="competencies"
    :options="{ handle: '.dragging__dots' }"
    class="content-sections"
  >
    <transition-group name="fade">
      <competence-row v-for="(item, index) in competencies" :model="item" :key="item.id" :index="index" />
    </transition-group>
  </draggable>
</template>

<script>
import CompetenceRow from './Row.vue';
import draggable from 'vuedraggable';

export default {
  name: 'VacancyPreferencesCompetenciesList',

  components: {
    CompetenceRow,
    draggable
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: Array
  },

  computed: {
    competencies: {
      get() {
        return this.value || [];
      },

      set(competencies) {
        this.$emit('change', competencies);
      }
    }
  }
};
</script>
